<template>
  <section class="asc-help-and-about-template--container">
    <asc-container class="asc-help-and-about-template--item">
      <template slot="header">
        <asc-surface-title title="HELP" />
      </template>
      <div class="asc-pdf-viewer-link">
        <p>
          To learn about Ascentia's features and functionality and to see
          Ascentia's frequently asked questions, download
          <a :href="pdfBlobUrl" :download="filename">
            Ascentia's User Guide PDF.
          </a>
        </p>
      </div>
    </asc-container>

    <asc-container v-if="contact" class="asc-help-and-about-template--item">
      <template slot="header">
        <asc-surface-title title="CONTACT" />
      </template>
      <p class="asc-help-text">
        For further support, contact the ARINC Service Desk:
      </p>
      <p class="asc-help-text">
        Phone: {{ contact.formattedPhone }}
        <span class="asc-help-text--italic"
          >(for North America, select option 1)</span
        >
      </p>
      <p class="asc-help-text">
        Email:
        <a
          v-if="contact.email"
          class="asc-help-email"
          :href="`mailto:${contact.email}`"
        >
          {{ contact.email }}
        </a>
      </p>
    </asc-container>

    <asc-container class="asc-help-and-about-template--item">
      <template slot="header">
        <asc-surface-title title="ABOUT" />
      </template>
      <p class="asc-help-text">
        Ascentia
        <sup>&reg;</sup>
      </p>
      <p class="asc-help-text">{{ getVersionNumber }}</p>
      <p class="asc-help-text">
        &#169; {{ getCurrentYear }} Collins Aerospace.
      </p>
      <p class="asc-help-text">All rights reserved.</p>
    </asc-container>
  </section>
</template>

<script>
import AscContainer from '@/components/atoms/AscContainer'
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle'

export default {
  name: 'AscHelpAndAboutTemplate',

  components: {
    AscContainer,
    AscSurfaceTitle,
  },
  props: {
    contact: {
      type: Object,
      default: () => {},
    },
    pdfDocument: {
      type: Blob,
      default: () => new Blob(),
    },
    version: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filename: 'AscentiaUserGuide.pdf',
    }
  },
  computed: {
    getVersionNumber() {
      return `Version ${this.version}`
    },
    getCurrentYear() {
      return new Date().getFullYear()
    },
    pdfBlobUrl() {
      if (!this.pdfDocument) return ''

      const blob = new Blob([this.pdfDocument], { type: 'application/pdf' })
      return URL.createObjectURL(blob)
    },
  },
  beforeDestroy() {
    // Revoke blob URL to free memory
    if (this.pdfBlobUrl) {
      URL.revokeObjectURL(this.pdfBlobUrl)
    }
  },
}
</script>

<style lang="scss">
.asc-pdf-viewer-link {
  & a {
    color: $accent-700 !important;
    text-decoration: none;
    outline: none !important;

    &:hover {
      text-decoration: underline;
    }
  }
}

.asc-help-and-about-template {
  &--item {
    margin-bottom: 16px;

    &:first-child {
      max-height: 495px;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .asc-header--h4 {
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 1px;
      line-height: 18px;
      padding-bottom: 16px;
    }

    .asc-help-text {
      color: $primary-black;
      line-height: 1.7;
      margin-bottom: 10px;

      &--italic {
        font-style: italic;
      }
    }

    .asc-help-email {
      @include link-styling;
    }
  }
}
</style>
